<template>
    <div>
        <div class="add-collab-modal">
            <v-dialog persistent v-model="addingCollab" width="1000px" height="500px">
                <v-card>
                    <v-card-title>
                        <div class="add-collab-modal-header">
                            <div class="add-collab-modal-title">Add a Collab Package</div>
                            <v-btn icon @click="addingCollab = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                    </v-card-title>
                    <v-card-text>
                        <v-form @submit="onSubmitPackage">
                            <v-row>
                                <v-col style="border-right: 1px solid #e1e2e3; padding-right: 30px;">
                                    <!-- Artist Info Fields -->
                                    <div class="add-collab-modal-subheader">Artist Info</div>
                                    <v-divider style="margin-bottom: 25px;"/>

                                    <v-file-input v-model="coverPhoto['file']" prepend-icon="mdi-camera" label="Upload Cover Photo" accept="image/*" :loading="uploadingPhoto" required filled dense></v-file-input>
                                    <v-text-field v-model="artistName" label="Artist Name" single-line required></v-text-field>
                                    <v-text-field v-model="packageName" label="Package Name" single-line required></v-text-field>
                                    <v-select v-model="genre" label="Genre" :items="genreList" single-line required></v-select>
                                    <v-textarea v-model="artistDescription" filled label="Artist description" rows="10"></v-textarea>
                                    <v-spacer/>
                                </v-col>
                                <v-col style="padding-left: 30px;">
                                    <!-- Loop Info Fields -->
                                    <div class="add-collab-modal-subheader">Loops</div>
                                    <v-divider/>

                                    <div v-for="loop in loopCount" :key="loop">
                                        <div>
                                            <v-text-field v-model="loopTitles[loop-1]" label="Loop Name"></v-text-field>
                                            <loop-submission v-model="loopItems[loop]" :uploadingState="uploadingState.loops ? uploadingState.loops[loop] : {}" :index="loop"/>
                                        </div>
                                    </div>
                                    <div style="display: flex; justify-content: flex-end;">
                                        <v-btn outlined class="collab-add-loop-btn" @click="onClickAddLoop">Add Loop</v-btn>
                                    </div>
                                    <v-card-text v-if="uploadingPackage" style="text-align: end; font-weight: bold; color: #18c684;">Now uploading files. This make take a few moments...</v-card-text>
                                </v-col>
                            </v-row>
                        </v-form>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn type="submit" @click="onSubmitPackage" class="collab-save-btn" color="primary" width="10%" :loading="uploadingPackage">Save</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog v-model="viewModal" width="600px">
                <v-card width="600px">
                    <div class="add-collab-modal-header">
                        <v-img :src="currentCollab.coverPhoto" height="350px" style="object-fit: cover">
                        </v-img>
                    </div>
                    <div style="display: flex; flex-direction: column;">
                        <div class="view-collab-artist-name">{{ currentCollab.artistName }}</div>
                        <div>
                            <v-card-text style="text-align: center; font-weight: bold; font-size: 17px; text-transform: capitalize">Genre > {{ currentCollab.genre }}</v-card-text>
                            <v-card-text style="font-size: 17px; font-weight: bold;">Description</v-card-text>
                            <v-card-text>{{ currentCollab.artistDescription }}</v-card-text>
                        </div>
                    </div>
                    <div>
                        <v-card v-for="(loop, index) in currentCollab.loops" :key="index" style="display: flex; margin: 10px 20px; align-items: center; justify-content: space-between;" outlined>
                            <div style="display: flex; align-items: center;">
                                <img width="80px" height="80px" :src="loop.coverUrl" alt="loop-cover" style="object-fit: cover; border-top-left-radius: 4px; border-bottom-left-radius: 4px;">
                                <div style="margin-left: 20px;">{{ loop.title }}</div>
                            </div>
                            <div style="margin-right: 20px;">{{ loop.bpm }} bpm</div>
                        </v-card>
                    </div>
                    <v-dialog v-model="deleteModal" width="500px">
                        <v-card width="500px">
                            <v-card-title>Deleting {{ currentCollab.artistName }}'s Collab</v-card-title>
                            <v-card-text>Are you sure you want to delete this collab?</v-card-text>
                            <v-card-actions>
                                <v-spacer/>
                                <v-btn color="red" @click="onDeleteCollab" :loading="deletingCollab" depressed>Yes, Delete</v-btn>
                                <v-btn outlined @click="deleteModal = false">Cancel</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-card-actions>
                        <v-spacer/>
                        <v-btn color="red" @click="onClickDelete" depressed>Delete</v-btn>
                        <v-btn outlined @click="viewModal = false">Close</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </div>
        <div id="collab-list-cont">
            <div class="collab-page-header">Collab List</div>
            <v-btn depressed outlined small width="200px" color="blue" class="collab-back" @click="onClickBack">
                <v-icon left>mdi-keyboard-backspace</v-icon>
                Back to Submissions
            </v-btn>
            <v-card v-for="(collab, index) in collabList" :key="index" style="margin: 10px 0; width: 800px; height: 100px; cursor: pointer;" outlined>
                <div class="collab-item">
                    <div style="display: flex; align-items: center">
                        <img class="collab-img" :src="collab.coverPhoto" alt="cover"/>
                        <div style="margin-left: 20px;">{{ collab.artistName }}</div>
                        <div style="margin-left: 20px;">{{ `${Object.keys(collab.loops).length} Loop ${Object.keys(collab.loops).length === 1 ? 'Pack' : 'Packs'}` }} </div>
                    </div>
                    <div class="collab-item-right-cont">
                        <div class="collab-upload-date">{{ uploadDate(collab.uploadDate) === 'Invalid date' ? '09.23.20' : uploadDate(collab.uploadDate) }}</div>
                        <v-btn color="primary" style="font-family: SFProText, sans-serif; margin-right: 20px; color: #fff;" @click="onClickViewCollab(collab)">View</v-btn>
                    </div>
                </div>
            </v-card>
            <v-btn absolute dark fab bottom right fixed color="#a644b6" class="add-collab" @click="addCollab">
                <v-icon>mdi-plus</v-icon>
            </v-btn>
        </div>
    </div>
</template>
<script>
    import { environment } from '../constants';
    import { db, fs } from '../config/firebaseInit';
    import firebase from 'firebase/app';
    import moment from 'moment';
    import LoopSubmission from "../components/LoopSubmission";
    export default {
        name: 'SampleList',
        components: {
          LoopSubmission
        },
        data() {
            return {
                collabList: [],
                currentCollab: {},
                addingCollab: false,
                loopCount: 1,
                loopItems: {
                  '1': {
                    title: '',
                    description: '',
                    cover: {},
                    coverUrl: '',
                    bpm: '',
                    demo: {},
                    demoUrl: '',
                    stemZip: '',
                    zipUrl: '',
                    stems: [],
                    stemUrls: []
                  }
                },
                loopTitles: [],
                artistName: '',
                packageName: '',
                genre: '',
                coverPhoto: {},
                artistDescription: '',
                uploadCoverPhotoTask: '',
                uploadDemoTask: '',
                uploadLoopListTask: '',
                uploadingPhoto: false,
                uploadedCoverPhoto: false,
                uploadingLoops: false,
                uploadedLoops: false,
                uploadingDemo: false,
                uploadingPackage: false,
                viewModal: false,
                deleteModal: false,
                deletingCollab: false,
                uploadingState: {
                  loops: {
                    '1': {
                      uploadingLoopCover: false,
                      uploadingStemZip: false,
                      uploadingDemo: false,
                      uploadingLoops: false
                    }
                  }
                },
                  genreList: [
                    'Alternative',
                    'Blues',
                    'Classical',
                    'Country',
                    'Dance & Electronic',
                    'Hip Hop/Rap',
                    'Holiday',
                    'Instrumental',
                    'Jazz',
                    'Musical Theatre',
                    'Orchestra',
                    'Pop',
                    'R&B',
                    'Rock',
                    'Religious/Gospel',
                    'Singer/Songwriter',
                    'Vocal/A capella',
                    'World'
                  ]
            }
        },
        mounted() {
          this.fetchCollabPackages();
        },
        methods: {
            onClickBack() {
                this.$router.push({ path: '/list' });
            },

            onClickAddLoop() {
                this.loopCount += 1;
            },

            addCollab() {
              this.resetFormFields();
              this.addingCollab = true;
            },

            fetchCollabPackages() {
              let collabList = []
              db.collection(`${environment}-collab`).orderBy('uploadDate', 'desc').get().then((querySnapshot) => {
                querySnapshot.forEach((result) => {
                  collabList.push({ ...result.data(), id: result.id });
                });
                this.collabList = collabList;
              })
            },

            resetFormFields() {
              this.loopCount = 1;
              this.loopItems = {
                  '1': {
                      title: '',
                      description: '',
                      cover: {},
                      coverUrl: '',
                      bpm: '',
                      demo: {},
                      demoUrl: '',
                      stemZip: '',
                      zipUrl: '',
                      stems: [],
                      stemUrls: []
                    }
              }
              this.artistName = '';
              this.artistDescription = '';
              this.packageName = '';
              this.genre = '';
              this.coverPhoto = {};
              this.loopTitles = [];
            },

            onClickViewCollab(collab) {
              this.currentCollab = collab;
              this.viewModal = true;
            },

            onClickDelete() {
              this.deleteModal = true;
            },

            onDeleteCollab() {
                const songRef = db.collection(`${environment}-collab`).doc(this.currentCollab.id);
                this.deletingCollab = true;
                songRef.delete().then(() => {
                    this.collabList.splice(this.collabList.indexOf(this.currentCollab), 1);
                    this.deletingCollab = false;
                    this.deleteModal = false;
                    this.viewModal = false;
                });
            },

            async onSubmitPackage() {
                this.uploadingPackage = true;
                this.uploadingLoops = true;
                await this.uploadArtistCover();
                await this.uploadAllAssets();
            },

            async uploadAllAssets() {
              return Promise.allSettled(this.loopTitles.map(async (_, index) => {
                await this.uploadLoopCover(this.loopItems[index+1].cover, index+1);
                await this.uploadDemo(this.loopItems[index+1].demo, index+1);
                await this.uploadStemZip(this.loopItems[index+1].stemZip, index+1);
                await this.uploadLoopList(this.loopItems[index+1].stems, index+1);
              })).then(() => {
                this.sendPackage();
              });
            },

            uploadArtistCover() {
              this.uploadCoverPhotoTask = fs.ref(`${environment}_collab-covers/${this.coverPhoto.file.name}`).put(this.coverPhoto.file);
              this.uploadCoverPhotoTask.on('state_changed', () => {
                this.uploadingState.uploadingPhoto = true;
              }, null, () => {
                this.uploadCoverPhotoTask.snapshot.ref.getDownloadURL().then((url) => {
                  this.coverPhoto.url = url;
                  this.uploadingState.uploadingPhoto = false;
                  this.uploadedCoverPhoto = true;
                })
              });
            },

            async uploadLoopCover(cover, index) {
              const uploadTask = fs.ref(`${environment}_collab-loop-covers/${cover.name}`).put(cover);
              uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                () => {
                  this.uploadingState.loops[index].uploadingLoopCover = true;
                },
                () => this.uploadingState.loops[index].uploadingLoopCover = false,
                async() => {
                  this.loopItems[index].coverUrl = await uploadTask.snapshot.ref.getDownloadURL();
                  this.uploadingState.loops[index].uploadingLoopCover = false;
                }
              )
              return uploadTask;
            },

            async uploadStemZip(zip, index) {
              const uploadTask = fs.ref(`${environment}_collab-loop-covers/${zip.name}`).put(zip);
              uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                () => {
                  this.uploadingState.loops[index].uploadingStemZip = true;
                },
                () => {
                  this.uploadingState.loops[index].uploadingStemZip = false
                },
                async() => {
                  this.loopItems[index].zipUrl = await uploadTask.snapshot.ref.getDownloadURL();
                  this.uploadingState.loops[index].uploadingStemZip = false;
                }
              )
              return uploadTask;
            },

            async uploadDemo(demo, index) {
              const uploadTask = fs.ref(`${environment}_collab-demos/${demo.name}`).put(demo);
              uploadTask.on(
                firebase.storage.TaskEvent.STATE_CHANGED,
                () => {
                  this.uploadingState.loops[index].uploadingDemo = true;
                },
                () => {
                  this.uploadingState.loops[index].uploadingDemo = false;
                },
                async() => {
                  this.loopItems[index].demoUrl = await uploadTask.snapshot.ref.getDownloadURL();
                  this.uploadingState.loops[index].uploadingDemo = false;
                }
              )
              return uploadTask;
            },

            async uploadLoopList(loopList, index) {
              const promises = []
              loopList.forEach((stem) => {
                const loopPromise = new Promise((resolve, reject) => {
                  const uploadTask = fs.ref(`${environment}_collab-stems/${stem.name}`).put(stem);
                  uploadTask.on(
                    firebase.storage.TaskEvent.STATE_CHANGED,
                    () => {
                      this.uploadingState.loops[index].uploadingLoops = true;
                    },
                    error => reject(error),
                    async() => {
                      const downloadUrl = await uploadTask.snapshot.ref.getDownloadURL();
                      this.loopItems[index].stemUrls.push({downloadUrl, name: stem.name.slice(0, -4)});
                      this.loopItems[index].title = this.loopTitles[index-1];
                      this.uploadingState.loops[index].uploadingLoops = false;

                      resolve({ downloadUrl, name: stem.name });
                    }
                  );
                })
                promises.push(loopPromise);
              });
              return Promise.allSettled(promises);
            },

          sendPackage() {
            let loops = {};
            Object.keys(this.loopItems).map((loop) => {
              let loopClone = Object.assign({}, this.loopItems[loop]);
              delete loopClone.stems;
              delete loopClone.demo;
              delete loopClone.cover;
              delete loopClone.stemZip;
              loops[loop] = loopClone;
            });
            const packageInfo = {
              artistName: this.artistName,
              packageName: this.packageName,
              artistDescription: this.artistDescription,
              genre: this.genre,
              coverPhoto: this.coverPhoto.url,
              uploadDate: moment().format(),
              loops
            }
            // Add package to DB collection:
            const loopCollection = db.collection(`${environment}-collab`).doc();
            loopCollection.set(packageInfo).then(() => {
              this.uploadingPackage = false;
              this.addingCollab = false;
              this.fetchCollabPackages();
            }).catch((error) => {
              console.log(error);
            });
          },
        },
          computed: {
            uploadDate() {
              return (date) => moment(date).format('MM.DD.YY');
            }
          },
        watch: {
            loopCount: function() {
                this.loopItems[this.loopCount] = {
                  title: '',
                  description: '',
                  cover: '',
                  coverUrl: '',
                  bpm: '',
                  demo: '',
                  demoUrl: '',
                  stemZip: '',
                  zipUrl: '',
                  stems: [],
                  stemUrls: []
                };

                this.uploadingState.loops[this.loopCount] = {
                  uploadingLoopCover: false,
                  uploadingStemZip: false,
                  uploadingDemo: false,
                  uploadingLoops: false
                }
            },
        },
    }
</script>
<style lang="scss">
    #collab-list-cont {
        display: flex;
        flex-direction: column;
        margin: 40px;
        font-family: SFProText, sans-serif;
        align-items: center;
    }

    .collab-page-header {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
    }

    .collab-back {
        margin: 20px 0;
    }

    .collab-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
    }

    .collab-img {
        width: 100px;
        height: 100px;
        object-fit: cover;
        border-top-left-radius: 4px;
        border-bottom-left-radius: 4px;
    }

    .add-collab {
        margin-bottom: 100px;
        margin-right: 40px;
    }

    .add-collab-modal-header {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .add-collab-modal-title {
        font-family: SFProText, sans-serif;
        font-weight: 600;
        font-size: 28px;
        margin-bottom: 20px;
    }

    .add-collab-modal-subheader {
        font-size: 20px;
        font-weight: bold;
        margin: 15px 0;
    }

    .add-collab-modal-add-track {
        display: flex;
        justify-content: space-between;
        width: 100%;
    }

    .add-track-list-item {
        border-bottom: 1px solid black;
        padding: 4px 0;
    }

    .collab-save-btn, .collab-add-loop-btn  {
        font-family: SFProText, sans-serif;
    }

    .view-collab-artist-name {
        font-size: 30px;
        font-weight: bold;
        text-align: center;
        margin-top: 40px;
    }

    .collab-item-right-cont {
        display: flex;
        align-items: center;
    }

    .collab-upload-date {
        opacity: 0.8;
        margin-right: 20px;
    }
</style>